"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaHuge = exports.mediaLarge = exports.mediaTabletAndLarger = exports.mediaDesktop = exports.TabletAndLarger = exports.Mobile = exports.Desktop = void 0;
var React = __importStar(require("react"));
var react_responsive_1 = __importDefault(require("react-responsive"));
var screenSizes = __importStar(require("./screenSizes"));
var Desktop = function (props) { return (React.createElement(react_responsive_1.default, __assign({}, props, { minWidth: screenSizes.small }))); };
exports.Desktop = Desktop;
var Mobile = function (props) { return (React.createElement(react_responsive_1.default, __assign({}, props, { maxWidth: screenSizes.small }))); };
exports.Mobile = Mobile;
var TabletAndLarger = function (props) { return (React.createElement(react_responsive_1.default, __assign({}, props, { minWidth: screenSizes.medium }))); };
exports.TabletAndLarger = TabletAndLarger;
exports.mediaDesktop = "@media (min-width: ".concat(screenSizes.small, ")");
exports.mediaTabletAndLarger = "@media (min-width: ".concat(screenSizes.medium, ")");
exports.mediaLarge = "@media (min-width: ".concat(screenSizes.large, ")");
exports.mediaHuge = "@media (min-width: ".concat(screenSizes.huge, ")");
//# sourceMappingURL=Viewports.js.map